/* eslint-disable ember/classic-decorator-no-classic-methods, ember/no-computed-properties-in-native-classes, ember/no-get */
import Controller from '@ember/controller';
import { tracked } from '@glimmer/tracking';
import { action, computed } from '@ember/object';
import { service } from '@ember/service';
import { isEmpty } from '@ember/utils';
import moment from 'moment';

export default class BankingController extends Controller {
  @service
  finance;

  @service
  router;

  @tracked
  depositDateDialogOpen;

  @computed('router.currentRouteName')
  get currentTab() {
    return this.get('router.currentRouteName').split('.')[3];
  }

  @computed('finance.nextDepositDate')
  get formattedDepositDate() {
    if (isEmpty(this.finance.nextDepositDate)) {
      return 'not set';
    }
    return moment(this.finance.nextDepositDate, 'YYYY-MM-DD').format(
      'DD/MM/YYYY',
    );
  }

  @action
  noop() {}

  @action
  openDepositDateDialog() {
    this.depositDateDialogOpen = true;
  }

  @action
  closeDepositDateDialog() {
    this.depositDateDialogOpen = false;
  }
}
